import { ChevronRight } from "@/components/flow/icons/ChevronRight"
import { LocalizedClientLink } from "@/components/ui/localized-client-link"

interface InteractiveLinkProps {
  href: string
  children?: React.ReactNode
  onClick?: () => void
}

export const InteractiveLink = ({ href, children, onClick, ...props }: InteractiveLinkProps) => {
  return (
    <LocalizedClientLink className="group flex items-center gap-x-1" href={href} onClick={onClick} {...props}>
      <p className="text-ui-fg-interactive font-sans text-[14px] font-normal whitespace-nowrap lg:text-[20px]">{children}</p>
      <ChevronRight color="var(--fg-interactive)" />
    </LocalizedClientLink>
  )
}
